import { useEffect, useState } from 'react';

export const useFullscreen = () => {
	const [isFullscreen, setIsFullscreen] = useState(false);

	const toggleFullScreen = () => {
		if (!document.fullscreenElement) {
			document.documentElement
				.requestFullscreen()
				.then(() => setIsFullscreen(true));
		} else if (document.exitFullscreen) {
			document.exitFullscreen().then(() => setIsFullscreen(false));
		}
	};

	useEffect(() => {
		const handleFullscreenChange = () => {
			setIsFullscreen(!!document.fullscreenElement);
		};

		document.addEventListener('fullscreenchange', handleFullscreenChange);

		return () => {
			document.removeEventListener('fullscreenchange', handleFullscreenChange);
		};
	}, []);

	return { isFullscreen, toggleFullScreen };
};
